"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconDecommissioning = function IconDecommissioning(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M33 20.984V5H10v20.58l-.005.258c-.076 1.923-.977 4.542-2.438 7.442l1.786.9.213-.427C11.086 30.633 12 27.814 12 25.58V10.9h13.77v-1H12V7h19v13.78h-.13c-6.136 0-11.11 4.974-11.11 11.11 0 1.843.448 3.58 1.242 5.11H8v2h14.333c2.038 2.444 5.106 4 8.537 4 6.136 0 11.11-4.974 11.11-11.11 0-5.407-3.863-9.912-8.98-10.906M44 24V12h-9v2h7v10zM22 41v2H12v-2zm8.87-18.22a9.11 9.11 0 1 1 0 18.22 9.11 9.11 0 0 1 0-18.22m-3.066 10.183.516.297v-3.19l-2.76 1.6.511.295-1.458 2.537-.051.1A1 1 0 0 0 25.48 36H30v-2h-2.793zm7.642-2.404 2.28 3.94a1 1 0 0 1-.753 1.495L36.86 36h-3.1v.59L31 35l2.76-1.59V34h1.366l-1.411-2.44zm-5.141-5.47a1 1 0 0 1 1.659-.108l.073.11 1.454 2.53.519-.3v3.19l-2.76-1.59.51-.297-.593-1.034-1.362 2.351-1.73-1.002z",
    clipRule: "evenodd"
  })));
};

export { IconDecommissioning, IconDecommissioning as default };
